<h1><a href="/admin-home">Admin</a> - International Subscription Requests</h1>

<section>
  <mat-form-field>
    <mat-label>Status</mat-label>
    <mat-select id="filterStatus" class="select" [(ngModel)]="selectedStatus" (selectionChange)="getRequests()">
      @for(s of statuses; track s) {
      <mat-option [value]="s.id">
        {{ s.name }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <p>{{loading}}</p>

  <mat-form-field>
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchText" (keyup)="applyFilter($event)" />
    @if(searchText) {
    <button matSuffix mat-icon-button aria-label="Clear search" (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
    }
  </mat-form-field>

  <div class="report-table-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Username </th>
        <td mat-cell *matCellDef="let row"> {{row.username}} </td>
      </ng-container>

      <ng-container matColumnDef="dealer_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Dealer name </th>
        <td mat-cell *matCellDef="let row"> {{row.dealer_name}} </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
        <td mat-cell *matCellDef="let row"> <a style="color: blue" href="mailto:{{row.email}}">{{row.email}}</a> </td>
      </ng-container>

      <ng-container matColumnDef="license_qty_requested">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Subscriptions Requested </th>
        <td mat-cell *matCellDef="let row"> {{row.license_qty_requested | number}} </td>
      </ng-container>

      <ng-container matColumnDef="request_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested On </th>
        <td mat-cell *matCellDef="let row"> {{ f.dateFormat(row.request_date) }} </td>
      </ng-container>


      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> {{ approvedOrDenied() }} </th>
        @if(isApproved()) {
        <td mat-cell *matCellDef="let row">
          <div class="container">
            <div class="left">
              <button (click)="approve(row.request_id, row.username, row.license_qty_requested)">Approve</button>
            </div>
            <div class="right">
              <button (click)="deny(row.request_id, row.username)">Deny</button>
            </div>
          </div>
        </td>
        } @else {
        <td mat-cell *matCellDef="let row"> {{ f.dateFormat(row.manager_approval_date) }} </td>
        }
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="15" [pageSizeOptions]="[15, 30, 45]" showFirstLastButtons>
  </mat-paginator>
  <br>
</section>

<!-- <section>
  <p>Status: <select id="filterStatus" (change)="getRequests()" [(ngModel)]="selectedStatus">
      @for (s of statuses; track s) {
      <option [value]="s.id">
        {{s.name}}
      </option>
      }
    </select>
  </p>
  <table class="data">
    <thead>
      <tr>
        <td>Username</td>
        <td></td>
        <td>Subscriptions Requested</td>
        <td>Requested On</td>
        <td>{{approvedOrDenied()}}</td>
        <td *ngIf="isApproved()"></td>
      </tr>
    </thead>
    <tbody>
      @for (row of report; track row) {
      <tr>
        <td>{{row.username}}</td>
        <td>{{row.dealer_name}} <a href="mailto:{{row.email}}">{{row.email}}</a></td>
        <td class="number">{{row.license_qty_requested}}</td>
        <td>{{f.dateFormat(row.request_date)}}</td>
        @if (isApproved()) {
        <td><button (click)="approve(row.request_id, row.username, row.license_qty_requested)">Approve</button></td>
        <td><button (click)="deny(row.request_id, row.username)">Deny</button></td>
        } @else {
        <td>{{f.dateFormat(row.manager_approval_date)}}</td>
        }
      </tr>
      }
    </tbody>
  </table>
</section> -->